import React from 'react';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import {
  KitCard,
  KitCardBody,
  KitButton,
} from 'components/common/cms-kit';
import { useTheme } from '@mui/material/styles';
import { Theme as MuiTheme } from '@mui/material/styles';

import { FeatureSwitch } from 'types/FetureSwitchTypes';

interface FeatureSwitchCardProps {
  featureSwitch: FeatureSwitch;
  editFunc: () => void;
  subscriptionValue?: string;
}

const CardLabel: React.FC<{ label: string }> = ({ label }) => {
  return (
    <Typography
      variant="subtitle2"
      component="span"
      sx={{
        color: "text.secondary",
        marginRight: "5px",
        display: "inline-block"
      }}>
      {label}
    </Typography>
  );
};

const CardValue: React.FC<{ value: React.ReactNode }> = ({ value }) => {
  return (
    <Typography
      variant="subtitle2"
      component="span"
      title={typeof value === 'string' ? value : undefined}
      sx={{
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "inline-block",
        overflow: "hidden",
        maxWidth: '300px',
        verticalAlign: 'middle'
      }}>
      {value}
    </Typography>
  );
};

const FeatureSwitchCard: React.FC<FeatureSwitchCardProps> = (props) => {
  const theme = useTheme() as MuiTheme;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <KitCard style={{ width: '80%', color: `${theme.palette.primary.main}` }}>
        <KitCardBody>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {props.featureSwitch?.switch_name}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              marginBottom: '10px',
              marginTop: '10px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div>
                <CardLabel label="Switch Type" />
                <CardValue value={props.featureSwitch?.switch_type} />
              </div>
              <div>
                <CardLabel label="Enabled" />
                <CardValue
                  value={
                    <Checkbox checked={props.featureSwitch.enabled} disabled />
                  }
                />
              </div>
              <div>
                <CardLabel label="Value" />
                <CardValue
                  value={
                    props.featureSwitch?.switch_type === 'Subscription'
                      ? props.subscriptionValue
                      : props.featureSwitch?.value
                  }
                />
              </div>
            </Box>
          </Box>
          <KitButton
            style={{ float: 'right' }}
            color="info"
            round
            size="sm"
            onClick={() => props.editFunc()}
            title="Edit"
          >
            <EditIcon /> Edit
          </KitButton>
        </KitCardBody>
      </KitCard>
    </Box>
  );
};

export default FeatureSwitchCard;
